'use client'
import Script from 'next/script'

export const AdDefend = () => {
  return <Script src="/adDefend.js" />
}
